// Global Instructions Rule Applied! - March 31, 2026
import type { ViewConfigColumn } from './types.ts'

/** Contact relationship columns — use contact search UI, not static multiselect options */
export function isContactFilterColumn(col: ViewConfigColumn | undefined): boolean {
  if (!col) return false
  return col.fieldType === 'contact' || col.filterType === 'contact'
}

/** Min/max numeric range (currency, valuation, range filter, etc.) */
export function isRangeFilterColumn(col: ViewConfigColumn | undefined): boolean {
  if (!col) return false
  if (col.filterType === 'range') return true
  const ft = col.fieldType ?? ''
  return ft === 'currency' || ft === 'number' || ft === 'valuation' || ft === 'ratio'
}

/** Min/max date range (cfg `filter_type='date_range'`, Date column type). */
export function isDateRangeFilterColumn(col: ViewConfigColumn | undefined): boolean {
  if (!col) return false
  if (col.filterType === 'date_range') return true
  const ft = col.fieldType ?? ''
  return ft === 'date'
}

/** Multi-select lookup-style (industry, pipeline stage, etc.) */
export function isSelectFilterColumn(col: ViewConfigColumn | undefined): boolean {
  if (!col) return false
  if (isContactFilterColumn(col)) return false
  if (col.filterType === 'multiselect') return true
  const ft = col.fieldType ?? ''
  return (
    ft === 'select' ||
    ft === 'company' ||
    ft === 'deal' ||
    ft === 'prospect' ||
    ft === 'city' ||
    ft === 'country'
  )
}

export function isCustomFilterColumn(col: ViewConfigColumn | undefined): boolean {
  return col?.filterType === 'custom'
}

/** Plain text / link-style typing */
export function isTextFilterColumn(col: ViewConfigColumn | undefined): boolean {
  if (!col) return true
  if (
    isRangeFilterColumn(col) ||
    isDateRangeFilterColumn(col) ||
    isSelectFilterColumn(col) ||
    isCustomFilterColumn(col) ||
    isContactFilterColumn(col)
  )
    return false
  return true
}
